
@if(lamellaArea()){
    @for (item of lamellaArea().assemblyArray; track item.index; ) {
        @if (isSpacingInput(item)){
            <app-spacing [spacingValues]="item" [spacingIdx]="!($first||$last) ? $index/2 : undefined" [relativeWidth]="relativeSpan(item.index)"/>
        } @else {
            <app-assembly-frame  [assemblyFrameValues]="item" [relativePosition]="relativePosition(item.index)" [hasFrame]="lamellaArea().frameProfile"/>
        }
    }
}
